<template>
  <div id="develop">
    <!-- <img v-if="tableData.picture" :src="tableData.picture" alt="" /> -->
    <img  src="../assets/img/u25965.png" alt="" />
    <div class="content">
      <ul style="line-height: 28px;font-size: 15px;">
        <li>
          活动名称：关爱生活
          <!-- <span>{{ tableData.activityName }}</span> -->
        </li>
        <li>
          活动时间：2021-07-12 至 2021-08-30
          <!-- <span>{{ tableData.beginTime }}</span> -->
        </li>
        <li>
          联系人：董先宝
          <!-- <span>{{ tableData.contactName }}</span> -->
        </li>
        <li>
          联系电话：18656596714
          <!-- <span>{{ tableData.phone }}</span> -->
        </li>
        <li>
          活动地点：安徽大学科技园
          <!-- <span>{{ tableData.address }}</span> -->
        </li>
        <li>活动内容：关爱老人生活</li>
          <!-- <span v-html="tableData.content"> </span></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  data() {
    return {
      tableData: {},
    }
  },

  created() {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        pageNo: 1,
        pageSize: 1,
      }
      this.$http
        .request({
          url: "/ypt/orgWork/communityActivity/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              console.log(res.code)
              return
            }

            this.tableData = res.content.list[0]
            console.log(this.tableData)
          }
        })
    },
  },
}
</script>

<style lang="less" scoped>
#develop {
  width: 400px;
  height: 40vh;
  padding: 20px;
  background: #091627;
  img {
    width: 100%;
  }

  .content {
    margin-top: 20px;
    color: #5caefe;
  }
}
</style>
